import { render, staticRenderFns } from "./CheckboxRestrictionFormElement.vue?vue&type=template&id=1d3880c2&scoped=true&"
import script from "./CheckboxRestrictionFormElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxRestrictionFormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3880c2",
  null
  
)

export default component.exports